module.exports = __webpack_public_path__ + "static/media/3.0e7bfec7.jpg";